import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import analytics from '@/shared-utils/analytics'
import { isIHeroCollection } from '@/shared-utils/content-model-type-guards'
import { HeroCollection } from '@pcln/horizon-customer-growth-components'
import { useEffect, useMemo } from 'react'
import { handleHeroCollectionSelect, sanitizeLink } from './utils'

export default function HeroCollectionWrapper() {
  const heroCollectionData = useContentfulVariation('heroCollection', isIHeroCollection)
  useEffect(() => {
    const heroCollectionGA4params = heroCollectionData?.analyticsTracking?.parameters
    if (heroCollectionGA4params) {
      analytics.fireGA4Event({
        event: 'view_promotion',
        attributes: {
          ...heroCollectionGA4params?.attributes,
        },
      })
    }
  }, [heroCollectionData])

  const sanitizedData = useMemo(() => {
    if (!heroCollectionData) return undefined

    return {
      ...heroCollectionData,
      heroImage: heroCollectionData.heroImage?.asset?.file?.url ? heroCollectionData.heroImage : undefined,
      heroLink: sanitizeLink(heroCollectionData.heroLink),
      collectionLink: sanitizeLink(heroCollectionData.collectionLink),
      collection: heroCollectionData.collection
        .filter((item) => item.image?.asset?.file?.url)
        .map((item) => ({ ...item, link: sanitizeLink(item.link) })),
    }
  }, [heroCollectionData])

  return (
    sanitizedData && (
      <ComponentMetricsBoundary componentId='HeroCollection'>
        <HeroCollection heroCollection={sanitizedData} handleSelect={handleHeroCollectionSelect} />
      </ComponentMetricsBoundary>
    )
  )
}
